<template>
    <div class="row align-items-center justify-content-center g-4">
        <div v-for="(item, index) in currentAchievementData" :key="index" class="col-lg-3 col-md-3 col-sm-6 col-6">
            <div class="achievement-wrap">
                <div class="achievement-content">
                    <h2 class="fs-1"><count-up :end-val="item.value" class="ctr d-inline-block"/>{{item.symbol}}</h2>
                    <p>{{item.title}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import CountUp from 'vue-countup-v3'
    import { achievementData } from '@/data/data';
    import { achievementDataEn } from '@/data/data';
    import { achievementDataTr } from '@/data/data';
    import { useI18n } from "vue-i18n"; 
    import { computed } from 'vue';
   
    const { locale } = useI18n();

    const currentAchievementData = computed(() => {
    if (locale.value === 'ar') {
        return achievementData;
    } else if (locale.value === 'tr') {
        return achievementDataTr;
    } else {
        return achievementDataEn;
    }
    });
</script>
